import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import UploadIcon from '@mui/icons-material/Upload';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { userContext } from '../../stores/users/userContext';
import { EMO_NAME } from '../constants';
import Footer from '../footer/footer';
import './home.css';

export default function Home() {
    const userStore = useContext(userContext);
    const navigate = useNavigate();

    const handleUploadClick = () => {
        if (userStore.isUserAuth()) {
            navigate('/upload-video/');
        } else {
            navigate('/login/');
        }
    };

   
    return (
        <Container maxWidth="md">
            <Box 
                className="home-container"
                sx={{ 
                    bgcolor: 'background.paper', 
                    boxShadow: 3 
                }}
            >
               
                <Typography 
                    variant="h6" 
                    component="h1" 
                    color="textSecondary"
                    className="home-subtitle"
                >
                    Welcome to <i>CherryClipz</i> the home of the <i>{EMO_NAME}</i><br/>
                    We Turn Every Quote into a playable and downloadable Video Clip!<br/>
                    Select in any order!<br/>
                    Cherry Pick Your Best Clips!<br />
                    <br />
                </Typography>
                
                <Typography 
                    variant="h5" 
                    component="h1" 
                    gutterBottom 
                    className="home-title"
                    sx={{ color: 'primary.main' }}
                >
                    {EMO_NAME} 
                </Typography>
                {/* Responsive video container that maintains 16:9 aspect ratio */}
                <Box className="video-container">
                    <iframe 
                        className="video-iframe"
                        src="https://www.youtube.com/embed/HYOHwyM5Edo?si=mn7bBHokvLTDvpO1" 
                        title="YouTube video player" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    />
                </Box>

                <Button
                    variant="contained"
                    size="large"
                    startIcon={<UploadIcon />}
                    onClick={handleUploadClick}
                    className="upload-button"
                    sx={{
                        boxShadow: 2,
                        '&:hover': {
                            boxShadow: 4,
                        }
                    }}
                >
                    {userStore.isUserAuth() ? 'Upload Video' : 'Get Started - Upload Video'}
                </Button>
            </Box>
            <Footer />
        </Container>
    );
}